export default "__VITE_ASSET__DrvGK9lO__"